import React from 'react';
import InputField from '../../../../components/input-field/InputField';
import ToggleRow from '../../../../components/toggle-row/ToggleRow';
import SmallJSONEditor from '../../../../components/small-json-editor/SmallJSONEditor';
import ValidationService from '../../../../services/ValidationService';
import RESTService from '../../../../services/RESTService';
import RoutingService from '../../../../services/RoutingService';
import ComponentHelper from '../../../../supers/ComponentHelper';
import TestRunnerModal from '../../../../components/test-runner-modal/TestRunnerModal';
import SampleRequestCard from '../../../../components/sample-request-card/SampleRequestCard';
import CommonService from '../../../../services/CommonService';
import _ from 'lodash';
import Dropdown from '../../../../components/dropdown/Dropdown';
const VS = new ValidationService();
const connect = new RESTService();
const RS = new RoutingService();
const CS = new CommonService();

class SqlConnector extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = this.defaultState();
		this.scanForParams();
		this.autoBind(['buildTypeDefault', 'scanForParams', 'onSetEmpty', 'onClearValue', 'onDefaultChange', 'getIsDisabled', 'onBuildConnection']);
	}

	getIsDisabled(field) {
		return this.data.disabled[field];
	}

	defaultState = () => {
		if (this.props.connection) {
			return this.onBuildConnectionState(this.props.connection);
		}

		return {
			testing: false,
			extraOptionsOpen: false,
			name: '',
			agentContent: '',
			agents: [],
			agentsOpen: false,
			domainName: '',
			port: 0,
			serverNameOrIpAddr: '',
			databasename: '',
			connTimeout: 0,
			reqTimeout: 0,
			username: '',
			password: '',
			sqlQuery: '',
			extraOptions: '',
			runningTest: false,
			requestParams: {},
			disabled: {}
		};
	};

	componentDidMount() {
		connect.getAgents().then(res => {
			this.setData('agents', res.data);
		});
	}

	onBuildConnectionState = conn => {
		let config = conn.configuration;

		let state = {
			testing: conn.testing,
			name: conn.name,
			agents: this.data.agents ? this.data.agents : [],
			agentsOpen: conn.agent && conn.agent.length > 0 ? true : false,
			type: 'sql-connector',
			agentContent: conn.agent ? conn.agent : '',
			domainName: config.domain ? config.domain : '',
			port: config.port ? config.port : 0,
			serverNameOrIpAddr: config.server ? config.server : '',
			databasename: config.database ? config.database : '',
			connTimeout: config.connectionTimeout ? config.connectionTimeout : 0,
			reqTimeout: config.requestTimeout ? config.requestTimeout : 0,
			username: config.user ? config.user : '',
			password: config.password ? config.password : '',
			sqlQuery: config.query ? config.query : '',
			extraOptions: config.options ? JSON.stringify(config.options, undefined, 2) : '',
			extraOptionsOpen: config.options ? true : false,
			runningTest: false,
			requestParams: {},
			disabled: {}
		};
		let disabled = {};
		if (state.testing || this.props.endpoint) {
			if (state.extraOptions.length > 0) {
				disabled.extraOptions = true;
			}
			if (state.domainName.length > 0) {
				disabled.domainName = true;
			}
			if (state.port.length > 0) {
				disabled.port = true;
			}
			if (state.serverNameOrIpAddr.length > 0) {
				disabled.serverNameOrIpAddr = true;
			}
			if (state.databasename.length > 0) {
				disabled.databasename = true;
			}
			if (state.username.length > 0) {
				disabled.username = true;
			}
			if (state.password.length > 0) {
				disabled.password = true;
			}
			if (state.sqlQuery.length > 0) {
				disabled.sqlQuery = true;
			}
			if (state.agentsOpen) {
				disabled.agent = true;
			}
		}
		state.disabled = disabled;

		return state;
	};

	onBuildConnection() {
		let data = this.data;
		this.invalidForm = false;
		let connection = {
			name: data.name,
			type: 'sql-connector',
			configuration: {}
		};

		let config = connection.configuration;

		if (data.domainName.length > 0) {
			config.domain = data.domainName;
		}
		if (data.port > 0) {
			config.port = parseInt(data.port, 10);
		}
		if (data.serverNameOrIpAddr.length > 0) {
			config.server = data.serverNameOrIpAddr;
			config.vendor = 'mssql';
		}
		if (data.databasename.length > 0) {
			config.database = data.databasename;
		}
		if (data.connTimeout > 0) {
			config.connectionTimeout = parseInt(data.connTimeout, 10);
		}
		if (data.reqTimeout > 0) {
			config.requestTimeout = parseInt(data.reqTimeout, 10);
		}
		if (data.username.length > 0) {
			config.user = data.username;
		}
		if (data.password.length > 0) {
			config.password = data.password;
		}
		if (data.sqlQuery.length > 0) {
			config.query = data.sqlQuery;
		}
		if (data.extraOptionsOpen) {
			if (data.extraOptions.length > 0) {
				let val = CS.safelyParseJSON(data.extraOptions);
				if (!val) {
					this.invalidForm = true;
					return;
				}
				config.options = val;
			}
		}
		if (data.agentsOpen) {
			connection.agent = data.agentContent;
		} else {
			connection.agent = '';
		}

		return connection;
	}

	isValidConnection = () => {
		if (this.data.name.length === 0) {
			return true;
		}

		if (this.data.extraOptionsOpen) {
			if (this.data.extraOptions.length === 0) {
				return true;
			}
		}
		return false;
	};

	onClearConnection = () => {
		this.observe(() => {
			this.data = this.defaultState();
		});
	};

	onValueChange = evt => {
		const { name, value } = evt.target;
		if (name === 'name' && !VS.validateName(value)) {
			return;
		}
		this.setData(name, value);
	};

	buildTestConnection = () => {
		let connection = this.onBuildConnection();
		if (this.invalidForm) {
			RS.smartError('Invalid JSON');
			return false;
		}
		let is = this.onBuildConnectionState(this.props.connection);
		let config = {};
		if (!is.extraOptionsOpen && this.data.extraOptionsOpen) {
			config.options = connection.configuration.options;
		}
		let data = this.data;
		if (data.domainName.length > 0 && is.domainName.length <= 0) {
			config.domain = data.domainName;
		}
		if (data.port > 0 && is.port <= 0) {
			config.port = connection.configuration.port;
		}
		if (data.serverNameOrIpAddr.length > 0 && is.serverNameOrIpAddr.length <= 0) {
			config.server = data.serverNameOrIpAddr;
			config.vendor = 'mssql';
		}
		if (data.databasename.length > 0 && is.databasename.length <= 0) {
			config.database = data.databasename;
		}
		if (data.connTimeout > 0 && is.connTimeout <= 0) {
			config.connectionTimeout = connection.configuration.connectionTimeout;
		}
		if (data.reqTimeout > 0 && is.reqTimeout <= 0) {
			config.requestTimeout = connection.configuration.requestTimeout;
		}

		if (data.username.length > 0 && is.username.length <= 0) {
			config.user = data.username;
		}
		if (data.password.length > 0 && is.password.length <= 0) {
			config.password = data.password;
		}
		if (data.sqlQuery.length > 0 && is.sqlQuery.length <= 0) {
			config.query = data.sqlQuery;
		}

		let testData = CS.buildRequestTestData(this.data.requestParams);
		testData._async = this.data.async ? true : false;
		return {
			application: 'global',
			sandbox: RS.getCurrentEnvironment(),
			endpoint: {
				action: 'query',
				configuration: config,
				connection: connection.name,
				templates: CS.buildRequestTemplate(this.data.requestParams),
				type: 'operation'
			},
			testValues: testData
		};
	};

	onTestConnection = () => {
		return connect.testConnection(this.buildTestConnection());
	};

	toggleTestRunner = () => {
		this.setData('runningTest', !this.data.runningTest);
	};

	runTest = () => {
		this.onBuildConnection();
		if (this.invalidForm) {
			RS.smartError('Invalid JSON');
			return;
		}
		this.observe(() => {
			this.data.runningTest = true;
		});
	};

	handleSQLQueryChange = newValue => {
		this.setData('sqlQuery', newValue);
	};

	handleExtraOptionsChange = newValue => {
		this.observe(() => {
			this.data.extraOptions = newValue;
			this.scanForParams();
		});
	};

	onChecked = evt => {
		const { dataset, checked } = evt.target;
		this.setData(dataset.name, checked);
	};

	onCreateConnection = () => {
		let connection = this.onBuildConnection();
		if (this.invalidForm) {
			RS.smartError('Invalid JSON');
			return;
		}
		if (this.props.connection) {
			delete connection.type;
			connect
				.updateConnection(connection)
				.then(res => {
					this.observe(() => {
						this.data = this.onBuildConnectionState(res.data);
					});
					RS.showSuccess();
				})
				.catch(err => {
					RS.smartError(err);
				});
		} else {
			connect
				.createConnection(connection)
				.then(() => {
					RS.showSuccess();
					RS.goToRoute('/connections');
				})
				.catch(err => {
					RS.smartError(err);
				});
		}
	};

	scanForParams() {
		let keys = ['extraOptions'];
		this.data.requestParams = CS.buildRequestParams(keys, this.data);
		if (this.props.endpointWatcher) {
			this.props.endpointWatcher({
				cmp: this,
				data: this.data,
				builder: this.buildTestConnection
			});
		}
	}

	onSetEmpty(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				this.data.requestParams[name].value = '';
			});
		}
	}

	onClearValue(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				this.data.requestParams[name].value = undefined;
			});
		}
	}

	onDefaultChange(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				let field = this.data.requestParams[name];
				field.value = evt.target.value;
				this.data.requestParams[name] = field;
			});
		}
	}

	buildTypeDefault(details, param) {
		return (
			<div className="inline-btn-input hbox vcenter default">
				<input
					className="text-input"
					type="text"
					placeholder={details.value === '' ? 'Empty String' : 'None'}
					value={details.value}
					data-name={param}
					onChange={this.onDefaultChange}
				/>
				<button className="btn inline-btn no-radius vbox hcenter vcenter" data-name={param} onClick={this.onSetEmpty}>
					Set as empty
				</button>
				<button className="btn inline-btn  vbox hcenter vcenter" data-name={param} onClick={this.onClearValue}>
					Clear
				</button>
			</div>
		);
	}

	toggleAsync = () => {
		this.setData('async', !this.data.async);
	};

	onAgentChange = evt => {
		if (evt.value) {
			this.setData('agentContent', evt.value);
		}
	};

	getAgentOptions = () => {
		let agents = [];
		_.forEach(this.data.agents, ag => {
			agents.push({
				label: ag.name,
				value: ag.name
			});
		});
		return agents;
	};

	render() {
		let {
			testing,
			extraOptionsOpen,
			name,
			domainName,
			port,
			agentsOpen,
			agentContent,
			serverNameOrIpAddr,
			databasename,
			connTimeout,
			reqTimeout,
			username,
			password,
			sqlQuery,
			extraOptions,
			runningTest,
			async
		} = this.data;
		return (
			<div className="sql-connector-cmp">
				<div className="step-card shadow animated fadeIn">
					<div className="hbox">
						<InputField
							label="Name"
							subText="Use only lowercase characters, numbers or hyphens."
							type="text"
							name="name"
							value={name}
							handleChange={this.onValueChange}
							disabled={this.props.connection ? true : false}
							required
							autoFocus
						/>
					</div>
					<div className="hbox">
						<InputField
							label="Domain Name"
							className="m-r-10"
							subText="If you set a domain name, the driver will connect to the SQL Server using domain login."
							type="text"
							name="domainName"
							value={domainName}
							handleChange={this.onValueChange}
							disabled={this.getIsDisabled('domainName')}
						/>
						<InputField
							label="Port"
							subText="Port to connect to (default: 1433). Don't set when connecting to a named instance."
							type="number"
							name="port"
							value={port}
							handleChange={this.onValueChange}
							disabled={this.getIsDisabled('port')}
						/>
					</div>
					<div className="hbox">
						<InputField
							label="Server Name or IP Address"
							className="m-r-10"
							subText="You can use localhost\instance to connect to a named instance."
							type="text"
							name="serverNameOrIpAddr"
							value={serverNameOrIpAddr}
							handleChange={this.onValueChange}
							required={this.props.endpointWatcher ? true : false}
							disabled={this.getIsDisabled('serverNameOrIpAddr')}
						/>
						<InputField
							label="Database Name"
							subText="Database to connect to (default: dependent on server configuration)."
							type="text"
							name="databasename"
							value={databasename}
							handleChange={this.onValueChange}
							required={this.props.endpointWatcher ? true : false}
							disabled={this.getIsDisabled('databasename')}
						/>
					</div>
					<div className="hbox">
						<InputField
							label="Connection Timeout"
							className="m-r-10"
							subText="Default is 15000ms."
							type="number"
							name="connTimeout"
							value={connTimeout}
							handleChange={this.onValueChange}
						/>
						<InputField
							label="Request Timeout"
							subText="Default is 15000ms."
							type="number"
							name="reqTimeout"
							value={reqTimeout}
							handleChange={this.onValueChange}
						/>
					</div>
					<div className="vbox">
						<div className="toggle-sub-title">Authentication</div>
					</div>
					<div className="hbox">
						<InputField
							className="m-r-10"
							label="Username"
							type="text"
							name="username"
							value={username}
							handleChange={this.onValueChange}
							disabled={this.getIsDisabled('username')}
						/>

						<InputField
							label="Password"
							type="password"
							name="password"
							value={password}
							handleChange={this.onValueChange}
							disabled={this.getIsDisabled('password')}
						/>
					</div>
					<div className="header-content vbox vcenter">
						<div className="toggle-sub-title">SQL Query {this.props.endpointWatcher ? <span>*</span> : ''}</div>
						<SmallJSONEditor
							name="sqlQuery"
							value={sqlQuery}
							onChange={this.handleSQLQueryChange}
							mode="sql"
							readOnly={this.getIsDisabled('sqlQuery')}
						/>
					</div>
					<ToggleRow
						name="Extra Options"
						details={
							this.props.endpoint
								? 'Extra options are vendor-specific.'
								: "Note that if you define options at connection-level you won't be able to add more options at endpoint-level."
						}
						toggleOn={extraOptionsOpen}
						keyName={'extraOptionsOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						content={
							<div className="header-content vbox vcenter">
								<SmallJSONEditor
									name="extraOptions"
									value={extraOptions}
									onChange={this.handleExtraOptionsChange}
									readOnly={this.getIsDisabled('extraOptions')}
								/>
								<div className="json-message">Options must be defined as a valid JSON object.</div>
							</div>
						}
					/>
					{!this.props.endpoint && (
						<ToggleRow
							name="Use an On-premise agent"
							details={
								'An agent is a process that runs in a virtual machine installed in a secure network. Once configured, it establishes a Web Socket connection with the Core Services platform, enabling the use of connectors that would otherwise be unreachable from the cloud.'
							}
							toggleOn={agentsOpen}
							keyName={'agentsOpen'}
							onToggle={this.onChecked}
							disabled={this.getIsDisabled('agent')}
							content={
								<div className="body-content vbox vcenter">
									<Dropdown
										className="w-100"
										label="Agent"
										value={agentContent}
										handleChange={this.onAgentChange}
										name="agentContent"
										disabled={this.getIsDisabled('agent')}
										options={this.getAgentOptions()}
									/>
								</div>
							}
						/>
					)}
					{testing &&
						!this.props.endpoint && (
							<div className="test-ctn vbox">
								<SampleRequestCard
									requestParams={this.data.requestParams}
									buildRequestFields={this.buildTypeDefault}
									validTest={true}
									async={async}
									toggleAsync={this.toggleAsync}
									onTest={this.runTest}
								/>
								<TestRunnerModal isOpen={runningTest} onClose={this.toggleTestRunner} runTest={this.onTestConnection} async={async} />
							</div>
						)}
					<div className={`btn-ctn ${this.props.endpoint ? 'hidden' : ''}`}>
						<button className="btn m-r-20" onClick={this.onClearConnection}>
							{this.props.connection ? 'Undo Changes' : 'Clear'}
						</button>
						<button className="btn primary" onClick={this.onCreateConnection} disabled={this.isValidConnection()}>
							{this.props.connection ? 'Save Connection' : 'Create Connection'}
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default SqlConnector;



// WEBPACK FOOTER //
// ./src/views/connections-panel/connection-creator/sql-connector/SqlConnector.js